import ROUTES from '../../../router/routing';

const articles = [
    {
        url: ROUTES.BLOG_EN_ARTICLE1,
        imgName: 'article1.png',
        alt: 'Customer communication enhancing with Umnico',
        date: '16.03.2022',
        title: 'How to Improve Customer Communication Effectiveness in 2024',
        text: 'Let’s find out some result-driven tactics',
    },
    {
        url: ROUTES.BLOG_EN_ARTICLE2,
        imgName: 'article2.png',
        alt: 'Messenger marketing and its benefits',
        date: '29.05.2022',
        title: 'What is Messenger Marketing (and Related Benefits)?',
        text: 'What it is and how to leverage it properly. Let’s find out!',
    },
    {
        url: ROUTES.BLOG_EN_ARTICLE3,
        imgName: 'article3.png',
        alt: 'Customer communication improvement with Umnico',
        date: '20.06.2022',
        title: 'How Can You Improve Customer Communication to Boost Sales?',
        text: 'Discover our tips on how to increase sales and forge stronger customer relationships.',
    },
    {
        url: ROUTES.BLOG_EN_ARTICLE4,
        imgName: 'article4.png',
        alt: 'Choosing the best omnichannel messaging platform for e-commerce',
        date: '28.06.2022',
        title: '5 Features to Consider When Choosing an Omnichannel Messaging Platform for E-commerce',
        text: 'How to choose the best communication platform for online trade',
    },
    {
        url: ROUTES.BLOG_EN_ARTICLE5,
        imgName: 'article5.jpg',
        alt: 'Using text-based communication properly and with a better return',
        date: '02.08.2022',
        title: 'How to Effectively Leverage Text-Based Communication',
        text: 'Analyzing pros and cons of texting and understanding how to best utilize this strategy',
    },
    {
        url: ROUTES.BLOG_EN_ARTICLE6,
        imgName: 'article6.jpg',
        alt: 'Live Chat for E-commerce: the Ultimate Guide by Umnico',
        date: '26.08.2022',
        title: 'Best Live Chat Apps for Ecommerce: the Ultimate Guide',
        text: 'Reviewing the champion online chat solutions for digital stores and how to leverage them properly',
    },
    {
        url: ROUTES.BLOG_EN_ARTICLE7,
        imgName: 'article7.jpg',
        alt: 'How to sell on WhatsApp Business – A brief guide for Beginners by Umnico',
        date: '07.09.2022',
        title: 'How to Sell Successfully on WhatsApp',
        text: 'Learn how to make sales on WhatsApp Business and maximize profit in 5 steps',
    },
    {
        url: ROUTES.BLOG_EN_ARTICLE8,
        imgName: 'article8.jpg',
        alt: 'CRM and Messenger integration',
        date: '28.09.2022',
        title: '7 Advantages of Integrating CRM with Messengers',
        text: 'Discover how integrating CRM system with messengers can improve your performance',
    },
    {
        url: ROUTES.BLOG_EN_ARTICLE9,
        imgName: 'article9.jpg',
        alt: 'Social CRM definition and best practices',
        date: '19.10.2022',
        title: 'Social CRM: What Is It and Why Your Might Need One',
        text: 'The complete guide on Social CRM, its capabilities and benefits for business',
    },
    {
        url: ROUTES.BLOG_EN_ARTICLE10,
        imgName: 'en-article10.jpg',
        alt: 'Social commerce guide',
        date: '21.11.2022',
        title: 'Social Commerce: How to Sell on Social Media in 2024',
        text: 'Come across social commerce and its sales-driven approaches',
    },
    {
        url: ROUTES.BLOG_EN_ARTICLE11,
        imgName: 'en-article11.png',
        alt: 'Best customer service platforms for business by Umnico',
        date: '16.12.2022',
        title: 'Top-10 Customer Service Software Platforms for Your Company in 2024',
        text: 'Discover the best customer service software platforms and their features',
    },
    {
        url: ROUTES.BLOG_EN_ARTICLE12,
        imgName: 'en-article12.jpg',
        alt: 'Best practices of using Live Chat in customer service',
        date: '12.01.2023',
        title: 'Live Chat for Customer Service: How to, Tips & Best Practices',
        text: 'The latest insights on how to deliver live chat customer service of unparalleled quality',
    },
    {
        url: ROUTES.BLOG_EN_ARTICLE13,
        imgName: 'en-article13.jpg',
        alt: 'Live Chat for Healthcare',
        date: '25.01.2023',
        title: 'Live Chat for Healthcare & Wellness: Top 6 Solutions',
        text: 'Discover how live chat transforms customer support in the industries of healthcare & wellness',
    },
    {
        url: ROUTES.BLOG_EN_ARTICLE14,
        imgName: 'en-article14.png',
        alt: 'Customer Service Trends in 2024 by Umnico',
        date: '22.02.2023',
        title: 'Customer Service Trends to Watch in 2024',
        text: 'Reviewing the trends in customer service every business should keep their eye on',
    },
    {
        url: ROUTES.BLOG_EN_ARTICLE15,
        imgName: 'en-article15.png',
        alt: 'Live chat software for real estate',
        date: '27.02.2023',
        title: 'Five of the Best Live Chat Software for the Real Estate Market',
        text: 'Check out the most capable live chat platforms for real estate companies',
    },
    {
        url: ROUTES.BLOG_EN_ARTICLE16,
        imgName: 'en-article16.png',
        alt: 'Social media management application advantages',
        date: '01.03.2023',
        title: '7 Benefits of Social Media Management Software for Growing Companies',
        text: 'We shed light on SMM applications and their core business advantages',
    },
    {
        url: ROUTES.BLOG_EN_ARTICLE17,
        imgName: 'en-article17.jpg',
        alt: 'WhatsApp Lead Generation by Umnico',
        date: '10.03.2023',
        title: 'WhatsApp Lead Generation: How to Get More Sales with the Messenger',
        text: 'Exploring the benefits of WhatsApp for lead gen and how to use it effectively',
    },
    {
        url: ROUTES.BLOG_EN_ARTICLE18,
        imgName: 'en-article18.png',
        alt: 'Live Chat for B2B, Umnico’s guide',
        date: '24.03.2023',
        title: 'Live Chat for B2B: Metrics and KPIs',
        text: 'Learn about b2b live chat’s essential metrics and performance indicators to track',
    },
    {
        url: ROUTES.BLOG_EN_ARTICLE19,
        imgName: 'en-article19.png',
        alt: 'Guide to the Instagram for business by Umnico',
        date: '18.04.2023',
        title: 'Instagram for Business: All You Need to Know',
        text: 'An in-depth guide for leveraging the social platform’s features for business',
    },
    {
        url: ROUTES.BLOG_EN_ARTICLE20,
        imgName: 'en-article20.jpg',
        alt: 'Customer communication in finance in South Africa',
        date: '18.01.2023',
        title: 'How Banks in South Africa Can Enhance Communication with Clients',
        text: 'First-hand review of customer communication in banking on an African continent',
    },
    {
        url: ROUTES.BLOG_EN_ARTICLE21,
        imgName: 'en-article21.png',
        alt: 'WhatsApp CRM by Umnico, how it helps businesses',
        date: '16.05.2023',
        title: 'WhatsApp CRM for Multiple Users: How It Works and Benefits for Business',
        text: 'Get to know how CRM software for WhatsApp empowers business communication',
    },
    {
        url: ROUTES.BLOG_EN_ARTICLE22,
        imgName: 'en-article22.png',
        alt: 'The ultimate guide to WhatsApp Manager by Umnico',
        date: '06.06.2023',
        title: 'The Best Way to Manage WhatsApp for Your Business',
        text: 'Get a clear picture of WhatsApp Manager benefits and capabilities',
    },
    {
        url: ROUTES.BLOG_EN_ARTICLE23,
        imgName: 'en-article23.png',
        alt: 'Chatbots vs. Human customer support. Guide by Umnico',
        date: '27.06.2023',
        title: 'Chatbots vs. Human Customer Support',
        text: 'Which option is more effective for your business?',
    },
    {
        url: ROUTES.BLOG_EN_ARTICLE24,
        imgName: 'en-article24.png',
        alt: 'Facebook messenger symbols meaning',
        date: '29.06.2023',
        title: 'What Do Facebook Messenger Icons and Symbols Mean?',
        text: 'Learn about the significance of icons you see in the messaging app',
    },
    {
        url: ROUTES.BLOG_EN_ARTICLE25,
        imgName: 'en-article25.png',
        alt: 'Chatbot for WhatsApp, Guide by Umnico',
        date: '04.07.2023',
        title: 'Chatbot for WhatsApp: The Ultimate Guide',
        text: 'Coming across the future of personalized and instant customer support',
    },
    {
        url: ROUTES.BLOG_EN_ARTICLE26,
        imgName: 'en-article26.png',
        alt: 'Bots for Telegram, the ultimate guide by Umnico',
        date: '13.07.2023',
        title: 'Bots for Telegram: Simplifying Tasks and Amplifying Communication',
        text: 'Exploring the variety of Telegram bots and their application',
    },
    {
        url: ROUTES.BLOG_EN_ARTICLE27,
        imgName: 'en-article27.png',
        alt: 'Instagram username ideas by Umnico',
        date: '25.07.2023',
        title: 'Instagram Username Ideas for Companies',
        text: 'Sharing tips and inspiration for picking the best nickname',
    },
    {
        url: ROUTES.BLOG_EN_ARTICLE28,
        imgName: 'en-article28.png',
        alt: 'How to create personal brand',
        date: '07.08.2023',
        title: 'How to Build a Personal Brand in Tech: 6 Steps',
        text: 'Learning the ropes of creating a strong professional identity',
    },
    {
        url: ROUTES.BLOG_EN_ARTICLE29,
        imgName: 'en-article29.png',
        alt: 'The complete guide to social widgets',
        date: '31.08.2023',
        title: 'Social Widgets - Unlocking its Potential: A Complete Guide for Marketers',
        text: 'Delving into aspects of social widget and their integration into a marketing strategy',
    },
    {
        url: ROUTES.BLOG_EN_ARTICLE30,
        imgName: 'en-article30.png',
        alt: 'Virtual Phone Number for WhatsApp',
        date: '07.09.2023',
        title: 'How to Create a Virtual Phone Number for WhatsApp',
        text: 'Guide to setting up a second number for texts and calls',
    },
    {
        url: ROUTES.BLOG_EN_ARTICLE31,
        imgName: 'en-article31.png',
        alt: 'Real-Time Marketing',
        date: '20.09.2023',
        title: 'Real-Time Marketing: How to Use it Effectively',
        text: 'Coming across the extensive opportunities of RTM for companies',
    },
    {
        url: ROUTES.BLOG_EN_ARTICLE32,
        imgName: 'en-article32.png',
        alt: 'Instagram CRM, the ultimate guide by Umnico',
        date: '27.09.2023',
        title: 'Instagram CRM for Business Owners, From Likes to Leads',
        text: 'Investigating how to use Instagram CRM to empower a business',
    },
    {
        url: ROUTES.BLOG_EN_ARTICLE33,
        imgName: 'en-article33.png',
        alt: 'Telegram CRM, the ultimate guide by Umnico',
        date: '05.10.2023',
        title: 'Telegram CRM: Mastering the Best Way of Chat Management',
        text: 'Grasping the practical benefits of CRM for Telegram',
    },
    {
        url: ROUTES.BLOG_EN_ARTICLE34,
        imgName: 'en-article34.png',
        alt: 'How to Write Out-of-Office Messages',
        date: '11.10.2023',
        title: 'Message Mastery: Writing Out-of-Office Messages That Work for You',
        text: 'Discovering the way of making absence notifications like a pro',
    },
    {
        url: ROUTES.BLOG_EN_ARTICLE35,
        imgName: 'en-article35.png',
        alt: 'Generative AI and its capabilities',
        date: '19.10.2023',
        title: 'Generative AI for Creativity and Innovation: What You Need to Know',
        text: 'Exploring the capabilities of generative models for business and more',
    },
    {
        url: ROUTES.BLOG_EN_ARTICLE36,
        imgName: 'en-article36.png',
        alt: 'Messaging on WhatsApp without saving a number, Umnico’s guide',
        date: '27.10.2023',
        title: 'Messaging On WhatsApp Without Saving a Number',
        text: 'Learning how to use the most popular instant messenger efficiently and professionally',
    },
    {
        url: ROUTES.BLOG_EN_ARTICLE37,
        imgName: 'en-article37.png',
        alt: 'EdTech trends - guide by Umnico',
        date: '10.11.2023',
        title: 'EdTech: 5 Trends to Watch in 2024',
        text: 'Coming across the hottest developments in education technology',
    },
    {
        url: ROUTES.BLOG_EN_ARTICLE38,
        imgName: 'en-article38.png',
        alt: '16 Side Hustle Ideas: explored by Umnico',
        date: '21.11.2023',
        title: 'Top-16 Side Hustle Ideas for Everyone',
        text: 'Giving you some side hustle ideas to make extra income',
    },
    {
        url: ROUTES.BLOG_EN_ARTICLE39,
        imgName: 'en-article39.png',
        alt: 'Best AI Art Generators, ultimate guide by Umnico',
        date: '27.11.2023',
        title: 'Best AI Art Generators for Commercial Use',
        text: 'Exploring the best artificial intelligent-based art generators for business',
    },
    {
        url: ROUTES.BLOG_EN_ARTICLE40,
        imgName: 'en-article40.png',
        alt: 'WhatsApp AI: Guide by Umnico',
        date: '12.12.2023',
        title: 'WhatsApp AI Opportunities: Enhance Your Communication',
        text: 'Discovering AI options to boost communication strategy in WhatsApp',
    },
    {
        url: ROUTES.BLOG_EN_ARTICLE41,
        imgName: 'en-article41.png',
        alt: 'Emotional marketing - guide by Umnico',
        date: '20.12.2023',
        title: 'Emotional marketing and how to employ it properly',
        text: 'Learn how to connect with clients through emotions',
    },
    {
        url: ROUTES.BLOG_EN_ARTICLE42,
        imgName: 'en-article42.png',
        alt: 'How to See Who Viewed your Instagram Story- Guide by Umnico',
        date: '22.12.2023',
        title: 'How to See Who Viewed Your Instagram Stories, Keep Them Private and Schedule in Advance',
        text: 'Essentials about the social media platform’s popular content form',
    },
    {
        url: ROUTES.BLOG_EN_ARTICLE43,
        imgName: 'en-article43.png',
        alt: 'The ultimate guide on RCS messaging by Umnico',
        date: '19.01.2024',
        title: 'Exploring RCS Messaging: Features, Benefits, And Comparison to SMS',
        text: 'Investigating Rich Communication Services messaging',
    },
    {
        url: ROUTES.BLOG_EN_ARTICLE44,
        imgName: 'en-article44.png',
        alt: 'Telegram marketing guide by Umnico',
        date: '12.02.2024',
        title: 'Telegram Marketing in 2024: The Ultimate Guide',
        text: 'Discover how to boost your brand and sales with Telegram',
    },
    {
        url: ROUTES.BLOG_EN_ARTICLE45,
        imgName: 'en-article45.png',
        alt: 'Most popular messaging apps — guide by Umnico',
        date: '19.02.2024',
        title: 'Most Popular Messaging Apps in 2024: A Comprehensive Overview',
        text: 'Exploring the messengers with the largest number of users',
    },
    {
        url: ROUTES.BLOG_EN_ARTICLE46,
        imgName: 'en-article46.jpg',
        alt: 'Voice over Internet Protocol – Umnico guide',
        date: '05.03.2024',
        title: 'Voice over Internet Protocol – VoIP: leveraging voice communication',
        text: 'Providing insights on VoIP telephony',
    },
    {
        url: ROUTES.BLOG_EN_ARTICLE47,
        imgName: 'en-article47.png',
        alt: 'Conversational Marketing - guide by Umnico',
        date: '12.03.2024',
        title: 'What is Conversational Marketing (Its Strategy, Benefits, and Examples)?',
        text: 'Mastering the Art of Conversational Marketing',
    },
    {
        url: ROUTES.BLOG_EN_ARTICLE48,
        imgName: 'en-article48.png',
        alt: 'WhatsApp Web guide by Umnico',
        date: '29.03.2024',
        title: 'WhatsApp Web: A Guide to WhatsApp Desktop on Any Device',
        text: 'Evaluating the capabilities of WhatsApp Web',
    },
    {
        url: ROUTES.BLOG_EN_ARTICLE49,
        imgName: 'en-article49.png',
        alt: 'Hot to use Telegram for Business | Umnico Guide',
        date: '08.04.2024',
        title: 'Telegram for Business: Step-by-Step Guide for Better Customer Communication',
        text: 'Assessing the messenger&apos;s potential for real-time communication with customers',
    },
    {
        url: ROUTES.BLOG_EN_ARTICLE50,
        imgName: 'en-article50.png',
        alt: 'Telegram Groups: Guide by Umnico',
        date: '16.04.2024',
        title: 'How a Company Can Take Advantage of Telegram Groups',
        text: 'Exploring the benefits of Telegram groups for marketing & customer communication',
    },
    {
        url: ROUTES.BLOG_EN_ARTICLE51,
        imgName: 'en-article51.png',
        alt: 'Facebook Messenger for Business | Guide by Umnico',
        date: '08.05.2024',
        title: 'How to use Facebook Messenger for Business in 2024',
        text: 'Discovering the messenger potential for sales and help desk',
    },
    {
        url: ROUTES.BLOG_EN_ARTICLE52,
        imgName: 'en-article52.png',
        alt: 'Instagram Marketing Guide by Umnico',
        date: '22.05.2024',
        title: 'Instagram Marketing Strategy: a Comprehensive Guide',
        text: 'Sharing insights on effective marketing on the popular social media platform',
    },
    {
        url: ROUTES.BLOG_EN_ARTICLE53,
        imgName: 'en-article53.png',
        alt: 'WhatsApp Marketing Guide by Umnico',
        date: '05.06.2024',
        title: 'WhatsApp Marketing in 2024: Guide for Business',
        text: 'Dive into the art of marketing through the most popular messenger',
    },
    {
        url: ROUTES.BLOG_EN_ARTICLE54,
        imgName: 'en-article54.png',
        alt: 'Facebook CRM - Guide by Umnico',
        date: '17.06.2024',
        title: 'CRM for Facebook Messenger: Key Features and Use Cases',
        text: 'Learn what Facebook CRM can bring to the table for your business',
    },
    {
        url: ROUTES.BLOG_EN_ARTICLE55,
        imgName: 'en-article55.png',
        alt: 'How to Create WhatsApp Business Account | Guide by Umnico',
        date: '22.07.2024',
        title: 'How to Create WhatsApp Business Account',
        text: 'Set up WhatsApp Business Account and take its full advantages',
    },
    {
        url: ROUTES.BLOG_EN_ARTICLE56,
        imgName: 'en-article56.png',
        alt: 'Facebook Marketing | Guide by Umnico',
        date: '29.07.2024',
        title: 'Facebook Marketing: Tips and Best Practices',
        text: "All it's needed to connect with customers via the social media powerhouse",
    },
    {
        url: ROUTES.BLOG_EN_ARTICLE57,
        imgName: 'en-article57.png',
        alt: 'Virtual Assistant for Digital Marketing | Umnico Guide',
        date: '12.08.2024',
        title: 'How a Virtual Assistant Can Help with Digital Marketing',
        text: 'Explore the benefits of online AI assistants for business',
    },
    {
        url: ROUTES.BLOG_EN_ARTICLE58,
        imgName: 'en-article58.png',
        alt: 'Viber marketing guide by Umnico',
        date: '27.08.2024',
        title: 'The Ultimate Guide to Viber Marketing',
        text: 'Master customer communication via the popular messaging app',
    },
    {
        url: ROUTES.BLOG_EN_ARTICLE59,
        imgName: 'en-article59.png',
        alt: 'Top Help desk Software - Guide by Umnico',
        date: '16.09.2024',
        title: 'Top-25 Help Desk Platforms for Small Business',
        text: 'Review the most popular ticketing systems',
    },
    {
        url: ROUTES.BLOG_EN_ARTICLE60,
        imgName: 'en-article60.png',
        alt: 'Chat marketing - Guide by Umnico',
        date: '30.09.2024',
        title: 'Chat Marketing: All You Need to Know',
        text: 'Discover the benefits of chat marketing and tips on using it effectively',
    },
    {
        url: ROUTES.BLOG_EN_ARTICLE61,
        imgName: 'en-article61.png',
        alt: 'Instagram Notes - Guide by Umnico',
        date: '14.10.2024',
        title: 'Instagram Notes: What They Are and How to Use Them',
        text: 'Get to know another communication tool on Instagram',
    },
    {
        url: ROUTES.BLOG_EN_ARTICLE62,
        imgName: 'en-article62.png',
        alt: 'Facebook Business verification guide by Umnico',
        date: '28.10.2024',
        title: 'Facebook Business Verification: How To Verify Business on Facebook',
        text: "Learn how to get the platform's blue check mark",
    },
    {
        url: ROUTES.BLOG_EN_ARTICLE63,
        imgName: 'en-article63.png',
        alt: 'Customer Interaction Management | Guide by Umnico',
        date: '25.11.2024',
        title: 'Customer Interaction Management: Tips & Benefits',
        text: 'Dive deep into the management of client interactions',
    },
    {
        url: ROUTES.BLOG_EN_ARTICLE64,
        imgName: 'en-article64.png',
        alt: 'Telegram Text Formatting Guide by Umnico',
        date: '16.12.2024',
        title: 'Mastering Telegram Messenger Formatting',
        text: 'Explore the messenger’s text customization capabilities',
    },
    {
        url: ROUTES.BLOG_EN_ARTICLE65,
        imgName: 'en-article65.png',
        alt: 'How to Run Facebook Ads - Guide by Umnico',
        date: '13.01.2025',
        title: 'How to Run Facebook Ads: Guide for 2025',
        text: 'Uncovering advertising capabilities of the social media powerhouse',
    },
    {
        url: ROUTES.BLOG_EN_ARTICLE66,
        imgName: 'en-article66.png',
        alt: 'Telegram Mini Apps Guide by Umnico',
        date: '10.02.2025',
        title: 'Telegram Mini Apps: How They Work and Their Benefits',
        text: "Master the messaging app's new feature",
    },
    {
        url: ROUTES.BLOG_EN_ARTICLE67,
        imgName: 'en-article67.png',
        alt: 'WhatsApp Commerce Guide | Umnico',
        date: '17.03.2025',
        title: 'WhatsApp Commerce: Key Features & Best Practices',
        text: 'Take a look at how to use the most popular messaging app for sales',
    },
    {
        url: ROUTES.BLOG_EN_ARTICLE68,
        imgName: 'en-article68.png',
        alt: ' Improving partner communication with Umnico | Fashion retailer case study',
        date: '14.04.2025',
        title: 'Case Study: How Fashion Retailer Improved Its Communication with Partners in Messaging Apps',
        text: 'How Umnico became a part of communication strategy',
    },
    {
        url: ROUTES.BLOG_EN_ARTICLE69,
        imgName: 'en-article69.png',
        alt: 'Customer Experience Optimization | Umnico Guide',
        date: '29.04.2025',
        title: 'Customer Experience Optimization: How to Make Clients Fall in Love with Your Products',
        text: 'Discover how to improve CX in the digital realm and beyond',
    },
    {
        url: ROUTES.BLOG_EN_ARTICLE70,
        imgName: 'en-article70.png',
        alt: 'How to Set Up Instagram Shop | Guide by Umnico',
        date: '26.05.2025',
        title: 'Setting Up an Instagram Shop: the Ultimate Guide',
        text: 'Learn how to set up a virtual storefront on the social media platform',
    },
];

export default articles;
